import chunk from 'lodash/chunk';
import * as React from 'react';
import styled from 'styled-components';
import {
  ITrendReportState,
  ITrendResult,
} from '../../../data/providers/reports/trendReportProvider';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { TrendCard } from './TrendCard';

interface IProps {
  state: ITrendReportState;
  pdfMode?: EPdfMode;
}

/**
 * @description renders cards in columns based on width of screen
 */
export const Trends = (props: IProps): React.ReactElement => {
  return (
    <GridContainer>
      {chunk(props.state?.data ?? [], 2).map(
        (rowData: ITrendResult[], index: number): React.ReactElement => {
          return (
            <GridRow key={index} pdfMode={props.pdfMode}>
              {rowData.map(
                (
                  trend: ITrendResult,
                  mIndex: number,
                  list: ITrendResult[]
                ): React.ReactElement | React.ReactElement[] => {
                  return list.length > 1 ? (
                    <TrendCard
                      whiskers={props.state.whiskers}
                      key={mIndex}
                      metric={trend.metric}
                      testType={trend.testType.name}
                      tags={trend.tags}
                      aggregate={trend.combined}
                      sessions={trend.sessions}
                      pdfMode={props.pdfMode}
                      timeframe={trend.timeframe}
                      isValid={trend.isValid}
                    />
                  ) : (
                    [
                      <TrendCard
                        whiskers={props.state.whiskers}
                        key={mIndex}
                        metric={trend.metric}
                        testType={trend.testType.name}
                        tags={trend.tags}
                        aggregate={trend.combined}
                        sessions={trend.sessions}
                        pdfMode={props.pdfMode}
                        timeframe={trend.timeframe}
                        isValid={trend.isValid}
                      />,
                      <Spacer key={99} pdfMode={props.pdfMode} />,
                    ]
                  );
                }
              )}
            </GridRow>
          );
        }
      )}
    </GridContainer>
  );
};

const Spacer = styled.div<{ pdfMode?: EPdfMode }>`
  flex: ${({ pdfMode }: { pdfMode?: EPdfMode }): number => (pdfMode ? 0 : 1)};
  margin-left: ${({ pdfMode }: { pdfMode?: EPdfMode }): string =>
    pdfMode === EPdfMode.PREVIEW || pdfMode === EPdfMode.PRINT
      ? '0px'
      : 'var(--grid-gap)'};
  @media (max-width: 990px) {
    margin-left: 0px;
    flex: 0;
  }
`;

const GridContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const GridRow = styled.div<{ pdfMode?: EPdfMode }>`
  display: flex;
  &:not(:first-child) {
    margin-top: var(--grid-gap);
  }

  flex-direction: ${({ pdfMode }: { pdfMode?: EPdfMode }): string =>
    pdfMode === EPdfMode.PREVIEW || pdfMode === EPdfMode.PRINT
      ? 'column'
      : 'row'};

  @media (max-width: 990px) {
    flex-direction: column;
    margin-top: 0px;
  }
  &:last-child {
    margin-bottom: ${({ pdfMode }: { pdfMode?: EPdfMode }): string =>
      pdfMode === EPdfMode.PREVIEW || pdfMode === EPdfMode.PRINT
        ? '0px'
        : 'calc(var(--grid-gap) * 2)'};
  }
`;
